import { CTA, Hero, Intro } from "../components/Section";
import { WorkGallery } from "../components/WorkGallery";
import { products } from "../content/site";
import { workImageSets } from "../content/workImages";

export function ProductsPage() {
  return (
    <>
      <Hero
        images={workImageSets.productsHero}
        title="Fabricated metal products for demanding project conditions."
        copy="Explore common products we fabricate for commercial, industrial, architectural, and site applications."
        primary={{ label: "Discuss a Product", href: "/contact" }}
      />
      <section className="product-lead section-pad" data-reveal>
        <div>
          <h2>Organized by material, geometry, finish, and use case.</h2>
          <p>
            Product examples can range from single fabricated parts to finished assemblies that require cutting, forming, welding, coating, and final preparation.
          </p>
        </div>
        <dl>
          <div>
            <dt>Material range</dt>
            <dd>Stainless, aluminum, carbon steel</dd>
          </div>
          <div>
            <dt>Process mix</dt>
            <dd>Cut, form, weld, finish, assemble</dd>
          </div>
          <div>
            <dt>Output types</dt>
            <dd>Parts, components, fixtures, assemblies</dd>
          </div>
        </dl>
      </section>
      <WorkGallery images={workImageSets.productsGallery} />
      <Intro
        eyebrow="Product Range"
        title="Built to match the project, finish, and field conditions."
        copy="Each product can be fabricated to project drawings, dimensions, material requirements, and installation needs."
      />
      <section className="product-grid section-pad" data-reveal>
        {products.map((product, index) => (
          <article className="product-card" key={product} data-reveal>
            <span>{String(index + 1).padStart(2, "0")}</span>
            <h3>{product}</h3>
          </article>
        ))}
      </section>
      <CTA
        title="Need a fabricated product outside these examples?"
        copy="Share the use case, the material, and the finish requirements. We will help determine the right fabrication path."
        label="Discuss a Product"
        href="/contact"
      />
    </>
  );
}
